export default __webpack_public_path__ + "static/media/e2-fullshow.d58671ac.jpeg";